export enum PageType {
  RESULTS = 'results',
  PRACTICE = 'practice',
  PRACTITIONER = 'practitioner',
  PROFILE = 'profile',
  BLOG_HOME = 'bloghome',
  INDEX = 'index',
  ARTICLE = 'article',
  HOME = 'home',
}
